import React, { useState } from 'react';
import { Flex } from 'rebass';
import EventList from '../List';
import EventCalendar from '../Calendar';
import { graphql, useStaticQuery } from 'gatsby';
import resolvePrismicEvent from './prismicResolver';
import Select from '../../Select';

const EventsShell = ({ filterFn, defaultView }) => {
  const [view, setView] = useState(defaultView);
  let {
    allPrismicEvent: { nodes: events },
  } = useStaticQuery(graphql`
    {
      allPrismicEvent(sort: { fields: data___start_date }) {
        nodes {
          id
          uid
          data {
            event_name {
              text
            }
            on_campus_event
            show_in_student_calendar
            virtual_event
            event_description {
              html
              text
            }
            start_date
            end_date
            start_time
            end_time
            venue_name
            street_address {
              html
            }
            city
            country
            state
            cost
            organizer_name
            organizer_phone_number
            organizer_email_address
            event_organizer_website {
              url
            }
            event_shopify_product
          }
        }
      }
    }
  `);
  events = events.map(resolvePrismicEvent);
  if (typeof filterFn === 'function') {
    events = events.filter(filterFn);
  }
  return (
    <>
      <Flex color="chestnutRose" m={-1} justifyContent="flex-end">
        <Select mb={3} value={view} onChange={e => setView(e.target.value)}>
          <option value="calendar">📅 Calendar</option>
          <option value="list">📃 List</option>
        </Select>
      </Flex>
      {view === 'calendar' && <EventCalendar events={events} />}
      {view === 'list' && <EventList events={events} />}
    </>
  );
};

EventsShell.defaultProps = {
  defaultView: 'list',
};

export default EventsShell;
